import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

import Dashboard from "../pages/Dashboard/index"

import CategoryIndex from "pages/Setting/Category"


import Payment from "pages/Finance/Expense/Payment"
import VendorPay from "pages/Finance/Expense/VendorPay"
import BankAccount from "pages/Finance/BankAccount/BankAccount"
import CreditCard from "pages/Finance/Credit Card/CreditCard"
import GstIndex from "pages/Finance/GST/GstIndex"
import TdsIndex from "pages/Finance/TDS/TdsIndex"
import ZtplIndex from "pages/Finance/Performa Invoice/Ztpl/ZtplIndex"
import AddPrfInvoice from "pages/Finance/Performa Invoice/Ztpl/AddPrfInvoice"
import EditPrfInvoice from "pages/Finance/Performa Invoice/Ztpl/EditPrfInvoice"
import ViewPrfInvoice from "pages/Finance/Performa Invoice/Ztpl/ViewPrfInvoice"
import TsgIndex from "pages/Finance/Performa Invoice/TSG/TsgIndex"
import AddTsgInvoice from "pages/Finance/Performa Invoice/TSG/AddTsgInvoice"
import ViewTsgInvoice from "pages/Finance/Performa Invoice/TSG/ViewTsgInvoice"
import EditTsgInvoice from "pages/Finance/Performa Invoice/TSG/EditTsgInvoice"
import ZithasTechIndex from "pages/Finance/Invoice/Ztpl/ZithasTechIndex"
import ViewZithasTechInvoice from "pages/Finance/Invoice/Ztpl/ViewZithasTechInvoice"
import ZithasInvoiceIndex from "pages/Finance/Invoice/Zithas/ZithasInvoiceIndex"
import ViewZithasInvoice from "pages/Finance/Invoice/Zithas/ViewZithasInvoice"
import AddZithasInvoice from "pages/Finance/Invoice/Zithas/AddZithasInvoice"
import EditZithasInvoice from "pages/Finance/Invoice/Zithas/EditZithasInvoice"
import CloneZithasInvoice from "pages/Finance/Invoice/Zithas/CloneZithasInvoice"
import StaffGuruIndex from "pages/Finance/Invoice/Staff Guru/StaffGuruIndex"
import ViewStaffGuruInvoice from "pages/Finance/Invoice/Staff Guru/ViewStaffGuruInvoice"
import ZithasPInvoiceIndex from "pages/Finance/Performa Invoice/Zithas/ZithasPInvoiceIndex"

import AccessDenied from "./AccessDenied"
import configure from "configure"
import CalenderIndex2 from "pages/Calender/CalenderIndex2"
import Crendential from "pages/Credentials/Crendential"
import Profile from "pages/Profile/Profile"


import KnowledgeBase from "pages/KnowledgeBase/KnowledgeBase"
import EditTopic from "pages/KnowledgeBase/EditTopic/EditTopic"
import AddTopic from "pages/KnowledgeBase/AddTopic/AddTopic"
import ViewTopic from "pages/KnowledgeBase/ViewTopic/ViewTopic"
import VendorsPay from "pages/FinanceModule/Expence/VendorsPay"
import Expense from "pages/FinanceModule/Expence/Expense"
import BudgetExpense from "pages/FinanceModule/Expence/Budget"
import CrediCardSection from "pages/FinanceModule/Expence/CreditCardSection"

// Work -> General Settings 
import DragDashboard from "pages/Dashboard/DragDashboard"
import OverDraft from "pages/Finance/Expense/Overdraft/OverDraft"
import OverdraftIndex from "pages/Setting/Finance/Overdraft/OverdraftIndex"
import Ztpl from "pages/FinanceModule/Performa_Invoice_Section/Ztpl"
import ViewPerInvoice from "pages/FinanceModule/Performa_Invoice_Section/ViewPerInvoice"
import ZtplTaxInvoice from "pages/FinanceModule/Invoice/ZtplTaxInvoice"
import ViewZtplInvoice from "pages/FinanceModule/Invoice/ViewZtplInvoice"
import ZithasInvoice from "pages/FinanceModule/Invoice/ZithasInvoice"
import ZithasInvoiceView from "pages/FinanceModule/Invoice/ViewZithasInvoice"
import Inventory from "pages/FinanceModule/Inventory/Inventory"
import InventoryIndex from "pages/Setting/Finance/Inventory/InventoryIndex"
import CalenderIndex3 from "pages/Calender/CalenderIndex3"
import HsnIndex from "pages/Setting/Finance/HsnIndex"
import InvoiceDetailIndex from "pages/Setting/Finance/Invoice"
import GstFinance from "pages/FinanceModule/GST/GstFinance"
import ZtplTdsPage from "pages/FinanceModule/TDS/ZtplTdsPage"
import ZithasTdsPage from "pages/FinanceModule/TDS/ZithasTdsPage"

// const authProtectedRoutes = [
//   {
//     path: `${configure.appUrl}dashboard`,
//     component: <DragDashboard />,
//     // component: <Dashboard />,
//   },
//   {
//     path: `${configure.appUrl}dashboard/drag_drop`,
//     component: <Dashboard />,
//     // component: <DragDashboard />,
//   },
//   {
//     path: `${configure.appUrl}profile`,
//     component: <Profile />,
//   },
//   {
//     path: `${configure.appUrl}roles`,
//     component: <Roles />,
//     module_id: "69",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}editroles/:id`,
//     component: <EditRoles />,
//     module_id: "69",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}addroles`,
//     component: <AddRoles />,
//     module_id: "69",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}addroles/:slug`,
//     component: <AddRolesDynamic />,
//     module_id: "69",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}staff`,
//     component: <Staff />,
//     module_id: "66",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}addstaff`,
//     component: <AddStaff />,
//     module_id: "66",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}edit-staff/:id`,
//     component: <EditStaff />,
//     module_id: "66",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}calendar`,
//     component: <CalenderIndex2 />,
//     module_id: "85",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}calender/:id`,
//     component: <CalenderIndex2 />,
//     module_id: "85",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}marketing/opportunity/logs`,
//     component: <ImportLogs />,
//   },
//   {
//     path: `${configure.appUrl}viewapprovedoc/:id`,
//     component: <ViewApproveDoc />,
//     module_id: "66",
//     type: "edit",
//   },


//   // Sales Module
//   {
//     path: `${configure.appUrl}setting/lead`,
//     component: <LeadIndex />,
//     moduleid: "3",
//   },
//   {
//     path: `${configure.appUrl}setting/introducer`,
//     component: <IntroducerIndex />,
//   },
//   {
//     path: `${configure.appUrl}setting/add-template`,
//     component: <AddTemplate />,
//   },
//   {
//     path: `${configure.appUrl}setting/edit-template`,
//     component: <EditTemplate />,
//   },
//   {
//     path: `${configure.appUrl}setting/contract`,
//     component: <ContractIndex />,
//     module_id: "76",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}setting/add-contract-template`,
//     component: <ContractAddTemplate />,
//     module_id: "76",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}setting/edit-contract-template/:id`,
//     component: <ContractEditTemplate />,
//     module_id: "76",
//     type: "edit",
//   },
//   { path: `${configure.appUrl}setting/proposal`, component: <ProposalIndex /> },

//   // setting module
//   {
//     path: `${configure.appUrl}setting/companysetting`,
//     component: <CompanySettingIndex />,
//     moduleid: "70",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}setting/generalsetting`,
//     component: <GeneralSettingIndex />,
//     module_id: "73",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}setting/generalsetting/:id`,
//     component: <EditCredential />,
//   },
//   {
//     path: `${configure.appUrl}setting/generalsetting/addtab`,
//     component: <AddCredential />,
//   },
//   {
//     path: `${configure.appUrl}setting/category`,
//     component: <CategoryIndex />,
//     module_id: "79",
//     type: "view",
//   },
//   { path: `${configure.appUrl}setting/bidding`, component: <BiddingIndex /> },
//   {
//     path: `${configure.appUrl}setting/add-letter-template`,
//     component: <LetterAddTemplate />,
//     // moduleid: "76",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}setting/edit-letters-template/:id`,
//     component: <LettersEditTemplate />,
//     // moduleid: "76",
//     type: "edit",
//   },

//   {
//     path: `${configure.appUrl}setting/invoice-details`,
//     component: <InvoiceDetailIndex />,
//     // module_id: "45",
//     type: "view",
//   },

//   // Sales Module > Lead
//   {
//     path: `${configure.appUrl}sales/lead`,
//     component: <Lead />,
//     module_id: "17",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}sales/add-lead`,
//     component: <AddLead />,
//     module_id: "17",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}sales/edit-lead/:id`,
//     component: <EditLead />,
//     module_id: "17",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}sales/opportunity-leads`,
//     component: <OpportunityLeads />,
//     module_id: "17",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}sales/junk-leads`,
//     component: <OpportunityLeads junk={true} />,
//     module_id: "17",
//     type: "view",
//   },
//   // Sales Module > Introducer
//   {
//     path: `${configure.appUrl}sales/introducer`,
//     component: <Introducer />,
//     module_id: "18",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}sales/add-introducer`,
//     component: <AddIntroducer />,
//     module_id: "18",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}sales/edit-introducer/:id`,
//     component: <EditIntroducer />,
//     module_id: "18",
//     type: "edit",
//   },
//   // Sales Module > Proposal
//   {
//     path: `${configure.appUrl}sales/proposal`,
//     component: <Proposal />,
//     module_id: "19",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}sales/add-proposal`,
//     component: <AddProposal />,
//     module_id: "19",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}sales/edit-proposal/:id`,
//     component: <EditProposal />,
//     module_id: "19",
//     type: "edit",
//   },

//   // Sales Module > Contract
//   {
//     path: `${configure.appUrl}sales/contract`,
//     component: <Contract />,
//     module_id: "20",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}sales/add-contract`,
//     component: <AddContract />,
//     module_id: "20",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}sales/edit-contract/:id`,
//     component: <EditContract />,
//     module_id: "20",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}sales/view-contract/:id`,
//     component: <ViewContract />,
//     module_id: "20",
//     type: "view",
//   },

//   // Sales Module > Customer
//   {
//     path: `${configure.appUrl}sales/customer`,
//     component: <Customers />,
//     module_id: "21",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}sales/add-customer`,
//     component: <AddCustomer />,
//     module_id: "21",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}sales/edit-customer/:id`,
//     component: <EditCustomer />,
//     module_id: "21",
//     type: "edit",
//   },

//   // 
//   {
//     path: `${configure.appUrl}sales/add-contact/:id`,
//     component: <AddContact />,
//     module_id: "20",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}sales/edit-contact/:id`,
//     component: <EditContact />,
//     module_id: "20",
//     type: "edit",
//   },

//   // setting module
//   { path: `${configure.appUrl}setting/icode`, component: <IcodeIndex /> },
//   {
//     path: `${configure.appUrl}setting/knowledge-base`,
//     component: <KnowledgeIndex />,
//     module_id: "81",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}setting/industry`,
//     component: <IndustryIndex />,
//     module_id: "83",
//     type: "view",
//   },
//   { path: `${configure.appUrl}setting/hosting`, component: <HostingIndex /> },

//   // Finance Module
//   { path: `${configure.appUrl}finance/payment`, component: <Payment /> },
//   { path: `${configure.appUrl}finance/vendor-pay`, component: <VendorPay /> },
//   {
//     path: `${configure.appUrl}finance/bank-account`,
//     component: <BankAccount />,
//   },
//   { path: `${configure.appUrl}finance/credit-card`, component: <CreditCard /> },
//   { path: `${configure.appUrl}finance/gst`, component: <GstIndex /> },
//   { path: `${configure.appUrl}finance/tds`, component: <TdsIndex /> },

//   // Performa Invoice
//   // ztpl
//   {
//     path: `${configure.appUrl}finance/ztpl-pinvoice`,
//     component: <ZtplIndex />,
//   },
//   {
//     path: `${configure.appUrl}finance/ztpl-add-pinvoice`,
//     component: <AddPrfInvoice />,
//   },
//   {
//     path: `${configure.appUrl}finance/ztpl-edit-pinvoice`,
//     component: <EditPrfInvoice />,
//   },
//   {
//     path: `${configure.appUrl}finance/ztpl-view-pinvoice`,
//     component: <ViewPrfInvoice />,
//   },

//   // Zithas
//   {
//     path: `${configure.appUrl}finance/zithas-pinvoice`,
//     component: <ZithasPInvoiceIndex />,
//   },

//   // TSG
//   {
//     path: `${configure.appUrl}finance/tsg-performa-invoice`,
//     component: <TsgIndex />,
//   },
//   {
//     path: `${configure.appUrl}finance/tsg-add-invoice`,
//     component: <AddTsgInvoice />,
//   },
//   {
//     path: `${configure.appUrl}finance/tsg-edit-pinvoice`,
//     component: <EditTsgInvoice />,
//   },
//   {
//     path: `${configure.appUrl}finance/tsg-view-invoice`,
//     component: <ViewTsgInvoice />,
//   },
//   // ==============

//   // Invoice
//   // ztpl
//   {
//     path: `${configure.appUrl}finance/zithas-technology-invoice`,
//     component: <ZithasTechIndex />,
//   },
//   {
//     path: `${configure.appUrl}finance/zithastech-view-invoice`,
//     component: <ViewZithasTechInvoice />,
//   },

//   // zithas
//   {
//     path: `${configure.appUrl}finance/zithas-invoice`,
//     component: <ZithasInvoiceIndex />,
//   },
//   {
//     path: `${configure.appUrl}finance/zithas-view-invoice`,
//     component: <ViewZithasInvoice />,
//   },
//   {
//     path: `${configure.appUrl}finance/zithas-add-invoice`,
//     component: <AddZithasInvoice />,
//   },
//   {
//     path: `${configure.appUrl}finance/zithas-edit-invoice`,
//     component: <EditZithasInvoice />,
//   },
//   {
//     path: `${configure.appUrl}finance/zithas-clone-invoice`,
//     component: <CloneZithasInvoice />,
//   },

//   // staffguru
//   {
//     path: `${configure.appUrl}finance/tsg-invoice`,
//     component: <StaffGuruIndex />,
//   },
//   {
//     path: `${configure.appUrl}finance/staffguru-view-invoice`,
//     component: <ViewStaffGuruInvoice />,
//   },

//   // Marketing Module
//   {
//     path: `${configure.appUrl}marketing/opportunity`,
//     component: <DataBankIndex />,
//     module_id: "22",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}marketing/Getindustrydetails/:industry_id`,
//     component: <ViewDataBank />,
//   },
//   {
//     path: `${configure.appUrl}marketing/Formshow/:company_id`,
//     component: <EditForm />,
//   },

//   // {
//   //   path: `${configure.appUrl}marketing/edit-bidding`,
//   //   component: <EditBidding />,
//   // },

//   {
//     path: `${configure.appUrl}marketing/cold-calling`,
//     component: <ColdCallingIndex />,
//     module_id: "24",
//     type: "view",
//   },
//   // {
//   //   path: `${configure.appUrl}marketing/add-coldcalling`,
//   //   component: <AddColdCalling />,
//   // },
//   // {
//   //   path: `${configure.appUrl}marketing/edit-coldcalling`,
//   //   component: <EditColdCalling />,
//   // },

//   // {
//   //   path: `${configure.appUrl}marketing/cold-calling`,
//   //   component: <ColdCallingIndex />,
//   // },
//   {
//     path: `${configure.appUrl}marketing/all-bookings`,
//     component: <Booking />,
//     module_id: "87",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}marketing/add-coldcalling`,
//     component: <AddColdCalling />,
//     module_id: "24",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}marketing/edit-coldcalling/:company_id`,
//     component: <EditColdCalling />,
//     module_id: "24",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}marketing/view-coldcalling`,
//     component: <ViewColdCalling />,
//     module_id: "24",
//     type: "view",
//   },

//   // work module
//   {
//     path: `${configure.appUrl}work/resource-plan`,
//     component: <ResourcePlanIndex />,
//   },
//   {
//     path: `${configure.appUrl}work/hosting`,
//     component: <HostingIndexMain />,
//     module_id: "29",
//     type: "view",
//   },

//   // this route should be at the end of all other routes
//   // eslint-disable-next-line react/display-name
//   {
//     path: `${configure.appUrl}`,
//     exact: true,
//     component: <Navigate to={`${configure.appUrl}dashboard`} />,
//   },
//   // Planet
//   { path: `${configure.appUrl}currentopening`, component: <CurrentOpening /> },
//   {
//     path: `${configure.appUrl}addcurrentopening`,
//     component: <AddCurrentOpening />,
//   },
//   {
//     path: `${configure.appUrl}editcurrentopening`,
//     component: <EditCurrentOpening />,
//   },
//   {
//     path: `${configure.appUrl}testimonial`,
//     component: <Testimonial />,
//   },
//   {
//     path: `${configure.appUrl}addtestimonial`,
//     component: <AddTestimonial />,
//   },
//   {
//     path: `${configure.appUrl}edittestimonial`,
//     component: <EditTestimonial />,
//   },
//   {
//     path: `${configure.appUrl}credentials`,
//     component: <Crendential />,
//     module_id: "10",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}viewdocument/:id`,
//     component: <ViewDocument />,
//   },
//   {
//     path: `${configure.appUrl}editdocument/:id`,
//     component: <EditDocument />,
//   },
//   {
//     path: `${configure.appUrl}audit/roles`,
//     component: <RolesPermission />,
//   },
//   // {
//   //   path: `${configure.appUrl}settingcredentials`,
//   //   // component: <GeneralSettingIndex />,
//   //   component: <Settingcredentials />,
//   // },
//   // {
//   //   path: `${configure.appUrl}editcredentials/:id`,
//   //   component: <EditIndex />,
//   // },

//   // Audit Logs route
//   {
//     path: `${configure.appUrl}audit-log/rolespermission`,
//     component: <RolesPermission />,
//   },

//   // Knowledge Base Module
//   {
//     path: `${configure.appUrl}knowledgebase`,
//     component: <KnowledgeBase />,
//     module_id: "95",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}edittopic`,
//     component: <EditTopic />,
//   },
//   {
//     path: `${configure.appUrl}addtopic`,
//     component: <AddTopic />,
//   },
//   {
//     path: `${configure.appUrl}viewtopic`,
//     component: <ViewTopic />,
//   },
//   // Finance route
//   {
//     path: `${configure.appUrl}expense/budget-expense`,
//     component: <BudgetExpense />,
//     module_id: "41",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}expense/expense`,
//     component: <Expense />,
//     module_id: "41",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}expense/vendorspay`,
//     component: <VendorsPay />,
//     module_id: "41",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}creditcard`,
//     component: <CrediCardSection />,
//     module_id: "43",
//     type: "view",
//   },

//   // Work Module 
//   {
//     path: `${configure.appUrl}work/activities`,
//     component: <GeneralTask />,
//     module_id: "26",
//     type: "view",
//   },

//   // Human Resource

//   {
//     path: `${configure.appUrl}payroll_management/swipe_issues`,
//     component: <SwipeAndIssuesIndex />,
//   },

//   // List of Holidays
//   {
//     path: `${configure.appUrl}holiday_list`,
//     component: <ListOfHolidays />,
//     module_id: "38",
//     type: "view",
//   },

//   {
//     path: `${configure.appUrl}flaws-gap`, component: <Reports />,
//     module_id: "96",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}notifications`,
//     component: <NotificationPage />
//   },

//   // Digital Marketing Project

//   {
//     path: `${configure.appUrl}weekly-plan/digital-marketing`,
//     component: <MainDmResourcePlan />,
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}teams-weekly-plan/digital-marketing`,
//     component: <TeamsWeeklyPlan />,
//     module_id: "98",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}project-weekly-plan/digital-marketing`,
//     component: <ProjectWeeklyPlan />,
//     module_id: "99",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}initial-project-plan/digital-marketing`,
//     component: <DigitalPlanIndex />,
//     module_id: "100",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}initial-project-plan/:id/:seo`,
//     component: <MainDmProjectPlan />,
//     module_id: "100",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}work/digital_marketing`,
//     component: <DigitalMarketingIndex />,
//     module_id: "101",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}digital_marketing/add_project`,
//     component: <DmAddProject />,
//     module_id: "101",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}digital_marketing/edit_project/:id`,
//     component: <EditProjectIndex />,
//     module_id: "101",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}work/digital_marketing/notes/:noteId`,
//     component: <DmSharedNotes />,
//     module_id: "101",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}setting/digital_marketing`,
//     component: <DigitalMarketingSeting />,
//     module_id: "102",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}complete_sprint`,
//     component: <CompleteSprint />,
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}monthly-planning`,
//     component: <MonthlyPlanning />,
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}monthly-approval`,
//     component: <DmMonthlyApproval />,
//     module_id: "105",
//     type: "view",
//   },

//   // Settings for overdraft
//   {
//     path: `${configure.appUrl}setting/overdraft`,
//     component: <OverdraftIndex />,
//     module_id: "104",
//     type: "view",
//   },

//   // Finance
//   {
//     path: `${configure.appUrl}finance/overdraft`,
//     component: <OverDraft />,
//     module_id: "103",
//     type: "view",
//   },

//   // Project Section 
//   {
//     path: `${configure.appUrl}work/projects`,
//     component: <ProjectIndex />,
//     module_id: "25",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}work/projects-plan/:id`,
//     component: <ProjectResourcePlanIndex />,
//     module_id: "25",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}work/add-project`,
//     component: <AddProject />,
//     module_id: "25",
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}work/edit-project/:id`,
//     component: <EditProject />,
//     module_id: "25",
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}complete_sprint/development`,
//     component: <ProjectSprintIndex />,
//     module_id: "25",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}initial-project-plan/development`,
//     component: <DevResourceIndex />,
//     module_id: "88",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}initial-project-plan/:id`,
//     component: <ResourceIndex />,
//     module_id: "88",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}weekly-plan/development`,
//     component: <PmResourcePlanIndex />,
//     module_id: "88",
//     type: "view",
//   },

//   {
//     path: `${configure.appUrl}maintenece-project-plan/:id`,
//     component: <MaintenanceResourceIndex />,
//     module_id: "88",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}work/edit-maintenance-project`,
//     component: <ExistingMaintenanceScreen />,
//     module_id: "25",
//     type: "edit",
//   },

//   // Gantt Chart
//   {
//     path: `${configure.appUrl}gantt-chart`,
//     component: <GanttChart />,
//     module_id: "106",
//     type: "view",
//   },

//   // // Support Section
//   {
//     path: `${configure.appUrl}support/ticket`,
//     component: <ProjectTickets />,
//     module_id: "27",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}support/tickets/:id`,
//     component: <SupportIndex />,
//     module_id: "27",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}support/test-cases`,
//     component: <TestCaseIndex />,
//     module_id: "107",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}support/test-cases/:id`,
//     component: <CaseIndex />,
//     module_id: "107",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}support/project-test/:id`,
//     component: <ProjectTestIndex />,
//     module_id: "107",
//     type: "view",
//   },

//   // Human Resource

//   {
//     path: `${configure.appUrl}payroll-management/salary-process`,
//     component: <SalaryIndex />,
//     module_id: 109,
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}payroll-management/salary-slip`,
//     component: <SalarySlip />,
//     module_id: 108,
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}payroll-management/emp-leave-summary`,
//     component: <SalaryLeave />,
//     // module_id: 108,
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}generate-salary-slip/:id`,
//     component: <GeneratedSalarySlip />,
//     module_id: 108,
//     type: "view",
//   },
//   // {
//   //   path: `${configure.appUrl}payroll-management/leave-management`,
//   //   component: <LeaveManagement />,
//   //   module_id: 40,
//   //   type: "view",
//   // },
//   {
//     path: `${configure.appUrl}payroll-management/leave-management`,
//     component: <DevLeaveManagement />,
//     module_id: 40,
//     type: "view",
//   },

//   // Reports
//   {
//     path: `${configure.appUrl}hr-report`,
//     component: <HrReport />,
//     module_id: 111,
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}timesheet-report`,
//     component: <TimeSheetReport />,
//     module_id: 32,
//     type: "view",
//   },

//   // Portfolio section

//   {
//     path: `${configure.appUrl}case-study`,
//     component: <CaseStudy />,
//     module_id: 113,
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}add-case-study`,
//     component: <AddCaseStudy />,
//     module_id: 113,
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}edit-case-study/:id`,
//     component: <EditCasestudy />,
//     module_id: 113,
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}view-case-study/:id`,
//     component: <ViewCaseStudy />,
//     // module_id: 113,
//     // type: "view",
//   },
//   {
//     path: `${configure.appUrl}portfolio`,
//     component: <Portfolio />,
//     // module_id: 114,
//     // type: "view",
//   },
//   {
//     path: `${configure.appUrl}add-portfolio`,
//     component: <Addportfolio />,
//     module_id: 114,
//     type: "add",
//   },
//   {
//     path: `${configure.appUrl}edit-portfolio/:id`,
//     component: <EditPortfolio />,
//     module_id: 114,
//     type: "edit",
//   },
//   {
//     path: `${configure.appUrl}view-portfolio/:id`,
//     component: <ViewPortfolio />,
//     module_id: 114,
//     type: "view",
//   },


//   {
//     path: `${configure.appUrl}ticket-planning`,
//     component: <TicketPlanning />,
//   },
//   {
//     path: `${configure.appUrl}earth-ticket-planning`,
//     component: <ShowTicketPlanning />,
//   },


//   {
//     path: `${configure.appUrl}marketing/tender`,
//     component: <TenderIndex />,
//     module_id: "115",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}marketing/add-tender/:id`,
//     component: <AddTender />,
//     module_id: "115",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}marketing/edit-tender/:id`,
//     component: <EditTender />,
//     module_id: "115",
//     type: "view",
//   },

//   {
//     path: `${configure.appUrl}marketing/bidding`,
//     component: <BiddingIndexMain />,
//     module_id: "23",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}marketing/add-bidding/:id`,
//     component: <AddBidding />,
//     module_id: "23",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}marketing/edit-bidding/:id`,
//     component: <EditBidding />,
//     module_id: "23",
//     type: "view",
//   },

//   // Invoice Section 
//   {
//     path: `${configure.appUrl}performa_invoice/ztpl`,
//     component: <Ztpl />,
//     module_id: "44",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}performa-invoice/view/:id`,
//     component: <ViewPerInvoice />,
//     module_id: "44",
//     type: "view",
//   },
//   // Inventory
//   {
//     path: `${configure.appUrl}finance/inventory`,
//     component: <Inventory />,
//     module_id: "117",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}setting/inventory`,
//     component: <InventoryIndex />,
//     module_id: "116",
//     type: "view",
//   },

//   // Tax Invoices
//   {
//     path: `${configure.appUrl}invoice/ztpl_invoice`,
//     component: <ZtplTaxInvoice />,
//     module_id: "45",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}finance/view-ztpl/:id`,
//     component: <ViewZtplInvoice />,
//     module_id: "45",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}invoice/zithas_invoice`,
//     component: <ZithasInvoice />,
//     module_id: "45",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}finance/view-zithas/:id`,
//     component: <ZithasInvoiceView />,
//     module_id: "45",
//     type: "view",
//   },

//   // Hirecy

//   {
//     path: `${configure.appUrl}company-structure`,
//     component: <Hirechynew />,
//     module_id: "116",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}customer-onboarding/:id`,
//     component: <ConvertCustomer />,
//     // module_id: "45",
//     // type: "view",
//   },

//   {
//     path: `${configure.appUrl}seo-report`,
//     component: <SeoReportIndex />,
//     // module_id: "118",
//     type: "view",
//   },
//   {
//     path: `${configure.appUrl}setting/hsn`,
//     component: <HsnIndex />,
//   },
// ]


const authProtectedRoutes = [
  {
    path: `${configure.appUrl}dashboard`,
    component: <DragDashboard />,
    // component: <Dashboard />,
  },
  {
    path: `${configure.appUrl}dashboard/drag_drop`,
    component: <Dashboard />,
    // component: <DragDashboard />,
  },
  {
    path: `${configure.appUrl}profile`,
    component: <Profile />,
  },

  // Expense
  {
    path: `${configure.appUrl}expense/budget-expense`,
    component: <BudgetExpense />,
    module_id: "41",
    type: "view",
  },
  {
    path: `${configure.appUrl}expense/expense`,
    component: <Expense />,
    module_id: "41",
    type: "view",
  },
  {
    path: `${configure.appUrl}expense/vendorspay`,
    component: <VendorsPay />,
    module_id: "41",
    type: "view",
  },
  {
    path: `${configure.appUrl}creditcard`,
    component: <CrediCardSection />,
    module_id: "43",
    type: "view",
  },

  // Invoice / Finance
  {
    path: `${configure.appUrl}performa_invoice/ztpl`,
    component: <Ztpl />,
    module_id: "44",
    type: "view",
  },
  {
    path: `${configure.appUrl}performa-invoice/view/:id`,
    component: <ViewPerInvoice />,
    module_id: "44",
    type: "view",
  },
  {
    path: `${configure.appUrl}invoice/ztpl_invoice`,
    component: <ZtplTaxInvoice />,
    module_id: "45",
    type: "view",
  },
  {
    path: `${configure.appUrl}finance/view-ztpl/:id`,
    component: <ViewZtplInvoice />,
    module_id: "45",
    type: "view",
  },
  {
    path: `${configure.appUrl}invoice/zithas_invoice`,
    component: <ZithasInvoice />,
    module_id: "45",
    type: "view",
  },
  {
    path: `${configure.appUrl}finance/view-zithas/:id`,
    component: <ZithasInvoiceView />,
    module_id: "45",
    type: "view",
  },


  {
    path: `${configure.appUrl}finance/inventory`,
    component: <Inventory />,
    module_id: "117",
    type: "view",
  },
  {
    path: `${configure.appUrl}finance/overdraft`,
    component: <OverDraft />,
    module_id: "103",
    type: "view",
  },

  {
    path: `${configure.appUrl}finance/finance-gst`,
    component: <GstFinance />,
    module_id: "46",
    type: "view",
  },

  // TDS
  {
    path: `${configure.appUrl}finance/ztpl-tds`,
    component: <ZtplTdsPage />,
    module_id: "47",
    type: "view",
  },
  {
    path: `${configure.appUrl}finance/zithas-tds`,
    component: <ZithasTdsPage />,
    module_id: "47",
    type: "view",
  },

  // Settings
  {
    path: `${configure.appUrl}setting/category`,
    component: <CategoryIndex />,
    module_id: "79",
    type: "view",
  },

  {
    path: `${configure.appUrl}setting/overdraft`,
    component: <OverdraftIndex />,
    module_id: "104",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/hsn`,
    component: <HsnIndex />,
  },
  {
    path: `${configure.appUrl}setting/invoice-details`,
    component: <InvoiceDetailIndex />,
    type: "view",
  },

  // Knowledge & Credentials
  {
    path: `${configure.appUrl}knowledgebase`,
    component: <KnowledgeBase />,
    module_id: "95",
    type: "view",
  },
  {
    path: `${configure.appUrl}credentials`,
    component: <Crendential />,
    module_id: "10",
    type: "view",
  },

  // Calendar
  {
    path: `${configure.appUrl}calendar`,
    component: <CalenderIndex2 />,
    module_id: "85",
    type: "view",
  },

  // Default redirect
  {
    path: `${configure.appUrl}`,
    exact: true,
    component: <Navigate to={`${configure.appUrl}dashboard`} />,
  },
];


const publicRoutes = [
  { path: `${configure.appUrl}logout`, component: <Logout /> },
  { path: `${configure.appUrl}login`, component: <Login /> },
  { path: `${configure.appUrl}forgot-password`, component: <ForgetPwd /> },
  { path: `${configure.appUrl}register`, component: <Register /> },
  { path: `${configure.appUrl}access-denied`, component: <AccessDenied /> },

  {
    path: `${configure.appUrl}calendar/:id`,
    component: <CalenderIndex3 />,
  },
  // {
  //   path: `${configure.appUrl}staff/Letters/:id`,
  //   component: <GenerateLinkLetters />
  // },
]

export { authProtectedRoutes, publicRoutes }
